import { render, staticRenderFns } from "./goodsrecord.vue?vue&type=template&id=9cbc2bde&scoped=true&"
import script from "./goodsrecord.vue?vue&type=script&lang=js&"
export * from "./goodsrecord.vue?vue&type=script&lang=js&"
import style0 from "./goodsrecord.vue?vue&type=style&index=0&id=9cbc2bde&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cbc2bde",
  null
  
)

export default component.exports